import React, {useCallback, useMemo} from 'react';

import {DomainGraphInterface} from 'app-core/framework/CoreObjectConstants';
import {asCoreObject, isCoreObjectWithInterface} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {handleToggleStar} from 'app-core/platform/starrable/CoreObjectStarIcon';
import isArchived from 'archive/isArchived';
import navigateToURL from 'lib/navigateToURL';
import SidepanelItem from 'nav/sidepanel/listing/SidepanelItem';
import {getIcon} from 'notebook/entry-templates/collections/sidepanel/CollectibleListingRenderer';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import fuzzydate from 'util/fuzzydate';

import {CollectibleListingGraphQL} from '../../../../graphql-fragments/notebook/templates/__generated/CollectibleListingGraphQL';

interface CollectibleSidepanelItemProps {
  isActive: boolean;
  isCompact: boolean;
  collectible: CollectibleListingGraphQL;
  isChild: boolean;
  isStarred: boolean;
}

export default function CollectibleSidepanelItem(props: CollectibleSidepanelItemProps): JSX.Element {
  const {isActive, isCompact, collectible, isChild, isStarred} = props;
  const date = fuzzydate(collectible.modifiedAt, {compact: isCompact, showTime: false});
  const subtitle = `${isCompact ? '' : 'Modified '}${date}`;
  const title = collectible.name;
  const icon = (
    <BenchlingIcon
      icon={getIcon(
        collectible.__typename,
        collectible.__typename === 'ProcedureNode' ? collectible.procedureType : undefined
      )}
    />
  );

  const shouldShowStar = useMemo(
    () => isCoreObjectWithInterface(collectible, DomainGraphInterface.STARRABLE),
    [collectible]
  );

  const handleClickStar = useCallback(() => {
    handleToggleStar({
      isStarred,
      item: asCoreObject(collectible),
    });
  }, [isStarred, collectible]);

  return (
    <SidepanelItem
      active={isActive}
      className="sidepanelItem--noIcon"
      faded={isArchived(collectible)}
      icon={icon}
      isCompact={isCompact}
      onClick={() => {
        navigateToURL(collectible.editUrl);
      }}
      parties={[{...collectible.creator, avatar_url: collectible.creator.avatar_url!}]}
      subTitle={subtitle}
      title={{
        text: title,
        node: <span>{title}</span>,
      }}
      tooltipText=""
      isExpandable={false}
      isChild={isChild}
      showStar={shouldShowStar}
      handleClickStar={handleClickStar}
      starred={isStarred}
    />
  );
}
